import React from "react"
import { Row, Col, Form, Input, InputNumber } from "antd"
import { formatInputNumber, parseInputNumber } from "../../utils"
import InventoryModalData from "../modals/InventoryModalData"

export interface MovementItemFormFieldsProps {
  selectedItem: boolean
  isEdit: boolean
  isServiceItem: boolean
  discountRate: number
  inventoryData: any[]
}

const MovementItemFormFields: React.FC<MovementItemFormFieldsProps> = ({
  selectedItem,
  isEdit,
  isServiceItem,
  discountRate,
  inventoryData,
}) => {
  return (
    <>
      {(selectedItem || isEdit) && (
        <Row gutter={[10, 10]}>
          <Col xs={24} sm={{ span: 10, offset: 2 }}>
            <Form.Item
              label={isServiceItem ? "Tipo / Modalidad" : "Presentación"}
              name="display"
              rules={[{ required: !isServiceItem, message: '' }]}
            >
              <Input disabled placeholder={isServiceItem ? "Servicio" : "presentación"} style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={{ span: 10 }}>
            <Form.Item
              label={isServiceItem ? "Cantidad (viajes, horas, unidades)" : "Cantidad por presentación"}
              name="quantity"
              rules={[{ required: true, message: '' }]}
            >
              <InputNumber 
                min={0}
                placeholder={isServiceItem ? "Cantidad de servicio" : "Ingresa la cantidad por presentación"}
                style={{ width: '100%' }}
                formatter={formatInputNumber}
                parser={parseInputNumber}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={{ span: 10, offset: 2 }}>
            <Form.Item
              label={isServiceItem ? "Costo / Precio unitario" : "Precio base presentación"}
              name="unit_price"
              rules={[{ required: true, message: '' }]}
            >
              <InputNumber 
                min={0}
                placeholder={isServiceItem ? "Costo del servicio" : "Precio por presentación"}
                prefix="$"
                style={{ width: '100%' }}
                formatter={formatInputNumber}
                parser={parseInputNumber}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={{ span: 10 }}>
            <Form.Item
              label="Descuento(%)"
              name="discount_rate"
              rules={[{ required: true, message: '' }]}
            >
              <InputNumber 
                min={0}
                placeholder="Descuento" 
                suffix="%"
                formatter={formatInputNumber}
                parser={parseInputNumber}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={{ span: 10, offset: 2 }}>
            <Form.Item
              label="Total base"
              name="total_amount"
              rules={[{ required: false, message: '' }]}
            >
              <InputNumber 
                disabled
                placeholder="Precio base total"  
                prefix="$"
                style={{ width: '100%' }}
                formatter={formatInputNumber}
                parser={parseInputNumber}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={{ span: 10 }}>
            <Form.Item
              label="Precio final"
              name="total_amount_full"
              rules={[{ required: false, message: '' }]}
            >
              <InputNumber 
                disabled
                placeholder="Precio final"  
                prefix="$"
                style={{ width: '100%' }}
                formatter={formatInputNumber}
                parser={parseInputNumber}
              />
            </Form.Item>
          </Col>
          {discountRate > 0 && (
            <Col xs={24} sm={{ span: 10, offset: 2 }}>
              <Form.Item
                label="Precio con descuento"
                name="total_amount_net"
                rules={[{ required: false, message: '' }]}
              >
                <InputNumber 
                  disabled
                  placeholder="Precio final con descuento"  
                  prefix="$"
                  style={{ width: '100%' }}
                  formatter={formatInputNumber}
                  parser={parseInputNumber}
                />
              </Form.Item>
            </Col>
          )}
        </Row>
      )}
      {!isServiceItem && <InventoryModalData inventoryData={inventoryData} />}
    </>
  )
}

export default MovementItemFormFields
